import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var PassEvent = /** @class */ (function (_super) {
    __extends(PassEvent, _super);
    function PassEvent(type, pass) {
        var _this = _super.call(this, type) || this;
        _this._pass = pass;
        return _this;
    }
    Object.defineProperty(PassEvent.prototype, "pass", {
        /**
         *
         */
        get: function () {
            return this._pass;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     */
    PassEvent.prototype.clone = function () {
        return new PassEvent(this.type, this._pass);
    };
    /**
     *
     */
    PassEvent.INVALIDATE = 'invalidatePass';
    return PassEvent;
}(EventBase));
export { PassEvent };
